import { parseBooleanValue } from "../../util";
import { IGenericCodebookItem } from "../model/GenericCodebookItem";

const GenericCodebookItemParamMapper = (item: IGenericCodebookItem) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid)
  };
};

export default GenericCodebookItemParamMapper;
